import React from 'react'

// interfaces / constants

// classes
import ListWrapper, { IProps as IListWrapperIProps } from './list_wrapper'

// helpers
import { useCallToActionWithFlag } from 'src/actions/onboarding_cta/onboarding_cta_hooks'

export const FeedWrapper: React.FC<IListWrapperIProps> = ({
  children,
  getNextPage,
  initialLoad
}) => {
  useCallToActionWithFlag()

  return (
    <ListWrapper getNextPage={getNextPage} initialLoad={initialLoad}>
      {children}
    </ListWrapper>
  )
}

export default FeedWrapper
